<div class="app-shell">
  <aside class="app-sidebar">
    <!-- Brand lockup -->
    <a class="app-brand" routerLink="/">
      <span class="app-brand__mark">C&amp;C</span>
      <span class="app-brand__type">
        <span class="app-brand__name">Cordell &amp; Cordell</span>
        <span class="app-brand__sub">Admin</span>
      </span>
    </a>

    <!-- Navigation. "Attorney Locations" is wired to the home route; the
         others are placeholders until their routes/pages exist — remove
         the is-disabled class and add a routerLink once they're built. -->
    <nav class="app-nav">
      <span class="app-nav__group">Scheduling</span>
      <a class="app-nav__item" routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
        <span class="material-icons">event</span>
        Attorney Locations
      </a>
      <a class="app-nav__item is-disabled" title="Coming soon">
        <span class="material-icons">apartment</span>
        Offices
      </a>
      <a class="app-nav__item is-disabled" title="Coming soon">
        <span class="material-icons">badge</span>
        Attorneys
      </a>

      <span class="app-nav__group">System</span>
      <a class="app-nav__item is-disabled" title="Coming soon">
        <span class="material-icons">settings</span>
        Settings
      </a>
    </nav>

    <!-- Account footer -->
    <div class="app-account">
      @if (isUserAuthenticated) {
        <div class="app-account__avatar">{{ username ? username.charAt(0) : 'U' }}</div>
        <div class="app-account__info">
          <span class="app-account__name">{{ username }}</span>
          <button class="app-account__logout" (click)="logout()">Logout</button>
        </div>
      } @else {
        <button class="app-account__login" (click)="login()">Login</button>
      }
    </div>
  </aside>

  <main class="app-content">
    <router-outlet></router-outlet>
  </main>
</div>
